const availableInsurances = ["chubb", "axa", "qualitas", "hdi", "gnp", "mapfre"];

export default availableInsurances;
